import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { get, isEmpty } from 'lodash-es';

import { venomHistory } from 'client/utils/history/venom-history';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { UserProfileModel } from 'client/data/models/profile/profile';
import { extractVinsWithLeads, getSavedItemsAmount } from 'site-modules/shared/components/profile/utils/extract-helper';
import { profileScreenMethods } from 'site-modules/shared/components/profile/profile-screen-methods';

import { InsiderNavigationDesktop } from './insider-navigation.desktop';
import { InsiderNavigationMobile } from './insider-navigation.mobile';

import './insider-navigation.scss';

export function InsiderNavigationComponent({
  isMobile = false,
  slug = 'inventory',
  idmData = null,
  signOut,
  privatePartyListing = null,
}) {
  const doSignOut = useCallback(() => {
    signOut();
    venomHistory.push('/');
  }, [signOut]);

  const NavigationComponent = isMobile ? InsiderNavigationMobile : InsiderNavigationDesktop;
  const isRegisteredUser = !isEmpty(idmData) && !idmData.isAnonymous;

  const savedItemsAmount = getSavedItemsAmount(idmData, privatePartyListing);
  const contactedItemsAmount = Object.keys(extractVinsWithLeads(idmData)).length;

  return (
    <div
      className={classnames('insider-navigation', {
        'registered-loaded': isRegisteredUser,
        'mt-1_25 mt-sm-0': !isMobile,
      })}
    >
      <NavigationComponent
        slug={slug}
        signOut={doSignOut}
        savedItemsAmount={savedItemsAmount}
        contactedItemsAmount={contactedItemsAmount}
      />
    </div>
  );
}

InsiderNavigationComponent.propTypes = {
  signOut: PropTypes.func.isRequired,
  slug: PropTypes.string,
  isMobile: PropTypes.bool,
  idmData: PropTypes.shape({}),
  privatePartyListing: PropTypes.arrayOf(PropTypes.shape({})),
};

const mapStateToProps = state => ({
  isAuthenticated: get(state, 'profile.isAuthenticated'),
  isAnonymousUser: get(state, 'profile.isAnonymousUser'),
});

export const InsiderNavigation = profileScreenMethods(
  connect(mapStateToProps)(
    connectToModel(InsiderNavigationComponent, {
      idmData: bindToPath(props => (props.isAuthenticated ? 'data.idm' : ''), UserProfileModel),
      privatePartyListing: bindToPath(
        props => (props.isAuthenticated && !props.isAnonymousUser ? 'data.privatePartyListing' : ''),
        UserProfileModel
      ),
    })
  )
);
